module.exports = __webpack_public_path__ + "static/game-24c0823ae109a435af0c6d81b840c0e6.jpeg";